import type { GlobalConfig } from './types';

export const initialState: GlobalConfig = {
	profileData: { name: 'John Doe' },
	feedbackCollector: {
		entryPointId: '',
	},
	siteId: '',
	experienceId: '',
	productKey: '',
	productHeader: '',
	orgId: '',
	assistanceServiceConfig: undefined,
	closeChat: () => {},
	emojiProvider: undefined,
	preventAbortRequestsOnStagingModalClose: false,
	preventAbortRequestsOnStandaloneChatClose: false,
	inProductExperience: '',
	smartCreationContext: undefined,
	autocompletePageContentSource: undefined,
	contextualPromptAnalyticsMetadata: undefined,
	moduleAnalyticsContext: undefined,
	analyticsProductHeader: undefined,
};
